import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesHighlight from './components/ServicesHighlight';
import AboutPreview from './components/AboutPreview';
import TestimonialsSection from './components/TestimonialsSection';
import CtaSection from './components/CtaSection';
import { useTitle } from '@/hooks/useTitle';
import { SchemaOrg } from '@/components/base/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL;

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  'name': '保險建築師',
  'url': siteUrl,
  'description': '保險建築師專注醫療保險、家庭保障、長期照護、退休規劃與保單健檢，以建築師思維為客戶量身打造保障藍圖。',
  'alternateName': 'Insurance Architect',
  'telephone': '+886-987-654-321',
  'email': 'info@insurancearchitect.com',
  'address': {
    '@type': 'PostalAddress',
    'addressCountry': 'TW',
    'addressRegion': '台灣',
  },
  'openingHoursSpecification': {
    '@type': 'OpeningHoursSpecification',
    'dayOfWeek': ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    'opens': '09:00',
    'closes': '18:00',
  },
  'sameAs': [
    'https://lin.ee/6XFYSq2',
  ],
  'hasOfferCatalog': {
    '@type': 'OfferCatalog',
    'name': '保險建築師服務項目',
    'itemListElement': [
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '個人醫療保險規劃' } },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '家庭保障規劃' } },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '資產與風險管理' } },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '企業團體方案' } },
      { '@type': 'Offer', 'itemOffered': { '@type': 'Service', 'name': '保單健檢' } },
    ],
  },
};

export default function Home() {
  useTitle({
    title: '保險建築師｜讓安心成為您的人生主結構',
    description: '保險建築師專注醫療保險、家庭保障、長期照護、退休規劃與保單健檢，透過傾聽、診斷、設計與追蹤，協助您建立更穩定的人生保障結構。',
    ogTitle: '保險建築師｜讓安心成為您的人生主結構',
    ogDescription: '不是急著賣保單，而是先理解您想守護誰、最怕失去什麼，再為您打造安心可以住一輩子的保障建築。',
    canonicalPath: '/',
  });
  return (
    <main>
      <SchemaOrg data={schemaData} />
      <Navbar />
      <HeroSection />
      <ServicesHighlight />
      <AboutPreview />
      <TestimonialsSection />
      <CtaSection />
      <Footer />
    </main>
  );
}